import { TableOption, TableOptions } from 'Design/components/Table'
import { Fragment, useState } from 'react'
import EditTrainingModal from './EditModal'

const TrainingOptions = (props) => {
  const [showEditModal, setShowEditModal] = useState(false)

  return (
    <Fragment>
      <TableOptions>
        <TableOption onClick={() => setShowEditModal(true)}>Provide Content Feedback</TableOption>
      </TableOptions>
      {showEditModal && <EditTrainingModal {...props} onHide={() => setShowEditModal(false)} />}
    </Fragment>
  )
}

export default TrainingOptions
